(function () {
  if (window.__balliProductCroInit) return;
  window.__balliProductCroInit = true;

  function randomInt(min, max) {
    const low = Math.ceil(min);
    const high = Math.floor(max);
    return Math.floor(Math.random() * (high - low + 1)) + low;
  }

  function readSession(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeSession(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      /* ignore */
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function minuteLabel(n) {
    return n === 1 ? 'minute' : 'minutes';
  }

  function initConfig(configEl) {
    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      return;
    }

    const productId = String(config.productId || 'product');
    const storageKey = (suffix) => `balli-cro-${suffix}-${productId}`;

    const viewingEl = document.querySelector('[data-cro-viewing]');
    const purchasedEl = document.querySelector('[data-cro-purchased]');
    const toastEl = document.querySelector('[data-cro-toast]');

    if (viewingEl) {
      let viewing = randomInt(config.viewMin || 8, config.viewMax || 42);
      viewingEl.textContent = String(viewing);

      window.setInterval(() => {
        const delta = randomInt(-2, 2);
        if (delta === 0) return;
        viewing = Math.min(config.viewMax || 42, Math.max(config.viewMin || 8, viewing + delta));
        viewingEl.textContent = String(viewing);
        viewingEl.classList.add('is-tick');
        window.setTimeout(() => viewingEl.classList.remove('is-tick'), 280);
      }, config.viewInterval || 4000);
    }

    if (purchasedEl) {
      const purchasedKey = storageKey('purchased');
      let purchased = readSession(purchasedKey);
      if (purchased === null) {
        purchased = String(randomInt(config.purchasedMin || 4, config.purchasedMax || 16));
        writeSession(purchasedKey, purchased);
      }
      purchasedEl.textContent = purchased;
    }

    if (!toastEl || !config.toastEnabled) return;

    const products = (config.toastProducts || []).filter((p) => p && p.title);
    if (!products.length) return;

    const toastImg = toastEl.querySelector('[data-cro-toast-img]');
    const toastTitle = toastEl.querySelector('[data-cro-toast-title]');
    const toastTime = toastEl.querySelector('[data-cro-toast-time]');
    const closeBtn = toastEl.querySelector('[data-cro-toast-close]');
    const minutesKey = storageKey('toast-minutes');

    let minutesMap = {};
    const storedMinutes = readSession(minutesKey);
    if (storedMinutes) {
      try {
        minutesMap = JSON.parse(storedMinutes) || {};
      } catch (error) {
        minutesMap = {};
      }
    }

    function getMinutes(title) {
      if (minutesMap[title]) return minutesMap[title];
      const mins = randomInt(config.recentMin || 3, config.recentMax || 58);
      minutesMap[title] = mins;
      writeSession(minutesKey, JSON.stringify(minutesMap));
      return mins;
    }

    let index = 0;
    let dismissed = false;
    let visible = false;

    function showToast(animate) {
      if (dismissed) return;
      const item = products[index];
      const mins = getMinutes(item.title);

      if (toastImg) {
        if (item.image) {
          toastImg.src = item.image;
          toastImg.alt = item.title;
          toastImg.hidden = false;
        } else {
          toastImg.removeAttribute('src');
          toastImg.hidden = true;
        }
      }

      if (toastTitle) {
        if (item.url) {
          toastTitle.innerHTML = `<a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>`;
        } else {
          toastTitle.textContent = item.title;
        }
      }

      if (toastTime) {
        toastTime.textContent = `${mins} ${minuteLabel(mins)} ago`;
      }

      toastEl.hidden = false;

      if (animate && visible) {
        toastEl.classList.remove('is-visible');
        window.setTimeout(() => {
          toastEl.classList.add('is-visible');
        }, 220);
      } else {
        window.requestAnimationFrame(() => {
          toastEl.classList.add('is-visible');
        });
      }

      visible = true;
    }

    function nextToast() {
      if (dismissed) return;
      index = (index + 1) % products.length;
      showToast(true);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        dismissed = true;
        toastEl.classList.remove('is-visible');
        window.setTimeout(() => {
          toastEl.hidden = true;
        }, 350);
      });
    }

    window.setTimeout(() => {
      showToast(false);
    }, 1800);

    window.setInterval(nextToast, config.toastInterval || 5000);
  }

  function boot() {
    document.querySelectorAll('[data-cro-config]').forEach(initConfig);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
